module.exports = __webpack_public_path__ + "img/logo_memberTest.860782a3.png";